import {RootState} from '../rootReducer';

export const modelMetadataSelector = (state: RootState) => state.modelMetadata;
export const modelMetadataOptionsSelector = (state: RootState) => state.modelMetadata.options;
